<template>
  <b-collapse class="py-3" id="my-collapse">
    <div class="container-fluid">
      <div class="d-flex justify-content-center text-center gap-2 flex-wrap">
        <div title="home">
          <b-button href="/" variant="outline-secondary" :class="activePage == 'Home' ? 'akkurate-green-bg text-white' : ''"><font-awesome-icon :icon="['fas', 'house-damage']" /></b-button>
        </div>
        <div title="Create Member">
          <b-button href="/mobile/member" variant="outline-secondary" :class="activePage == 'Create Member' ? 'akkurate-green-bg text-white' : ''"><font-awesome-icon :icon="['fas', 'plus']" /></b-button>
        </div>
        <div title="All Members">
          <b-button href="/mobile/all-members" variant="outline-secondary" :class="activePage == 'All Members' ? 'akkurate-green-bg text-white' : ''"><font-awesome-icon :icon="['fas', 'users']" /></b-button>
        </div>
        <!-- <div title="deposit">
          <b-button href="/mobile/deposit" variant="outline-secondary"><font-awesome-icon :icon="['fas', 'forward']" /></b-button>
        </div>
        <div title="withdrawal">
          <b-button href="/mobile/withdrawal" variant="outline-secondary"><font-awesome-icon :icon="['fas', 'backward']" /></b-button>
        </div> -->
        <div title="Other Receipt">
          <b-button href="/mobile/other-receipt" variant="outline-secondary" :class="activePage == 'Other Receipt' ? 'akkurate-green-bg text-white' : ''"><font-awesome-icon :icon="['fas', 'money-bill-transfer']" /></b-button>
        </div>
        <div title="transaction history">
          <b-button href="/mobile/history" variant="outline-secondary" :class="activePage == 'Transaction History' ? 'akkurate-green-bg text-white' : ''"><font-awesome-icon :icon="['fas', 'book']" /></b-button>
        </div>
        <div title="user profile">
          <b-button href="/mobile/profile" variant="outline-secondary" :class="activePage == 'User Profile' ? 'akkurate-green-bg text-white' : ''"><font-awesome-icon :icon="['fas', 'user']" /></b-button>
        </div>
      </div>
    </div>
  </b-collapse>
</template>
<script>
export default {
  props: {
    activePage: {
      type: String,
      default: "Home"
    }
  }
};
</script>